import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { setAmbulanceCrewSignature } from '../store/signatures.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getAmbulanceSignature() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }
  try {
    const pcr: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcr._attachments) {
      if (pcr._attachments.StandardSignatures_Section1_Ambulance !== undefined) {
        const ambulanceSignature = pcr._attachments.StandardSignatures_Section1_Ambulance
        const signature = document.createElement('img')
        signature.src = 'data:' + ambulanceSignature.fileExtension + ';base64,' + ambulanceSignature.data
        yield put(setAmbulanceCrewSignature(signature.src))
      } else {
        yield put(setAmbulanceCrewSignature(null))
      }
    } else {
      yield put(setAmbulanceCrewSignature(null))
    }
  } catch (e) {
    yield put(throwPcrException(`getAmbulanceSignature() error: ${e}`))
  }
}

export function* getAmbulanceSignatureSaga() {
  yield takeLatest([SignaturesConstants.GET_SIGNATURES], performWithMutexHOG, getAmbulanceSignature)
}
